import React, { Component } from 'react'
import { NotificationManager, NotificationContainer } from 'react-notifications'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import IntlMessages from 'util/IntlMessages'
import { Button } from 'reactstrap'
import Logo from 'assets/images/logo.jpg'

import {
  FORGOT_PASSWORD
} from 'constants/actionTypes'
import { createUnrestrictedAction } from 'util/actionCreators'

class ForgotPassword extends Component {
  constructor (props) {
    super(props)

    this.state = {
      email: 'glen@majocchi.it'
    }
  }

  handleChange (event) {
    this.setState({ [event.target.name]: event.target.value })
  }

  handleSubmit () {
    this.props.createUnrestrictedAction('users', FORGOT_PASSWORD, 'POST', { data: this.state }, (response) => {
      return (
        NotificationManager.success(
          response.message,
          '',
          3000
        )
      )
    })
  }

  render () {
    const { email } = this.state
    return (
      <div
        className='app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3'>
        <div className='login-content'>
          <div className='login-header mb-4 text-center'>
            <Link className='app-logo' to='/' title='Majocchi Listino'>
              <img src={Logo} alt='majocchi' title='majocchi' />
            </Link>
          </div>

          <div className='mb-2'>
            <h2><IntlMessages id='appModule.forgotPassword' /></h2>
          </div>

          <div className='login-form'>
            <div>
              <input
                type='email'
                placeholder='Your Email'
                className='mt-0 mb-4 form-control form-control-lg'
                name='email'
                value={email}
              />

              <Button className='btn btn-primary' onClick={this.handleSubmit.bind(this)}>
                <IntlMessages id='appModule.resetPassword' />
              </Button>

            </div>
          </div>
        </div>
        <NotificationContainer />
      </div>
    )
  }
}

export default connect(null, { createUnrestrictedAction })(ForgotPassword)



// WEBPACK FOOTER //
// ./containers/ForgotPassword.js